import React from 'react';
import logo from '../assets/logoIcon.png';
import { Block } from '../content';
import '../assets/components.css';
const SIZES = {
  big: 150,
  medium: 90,
  small: 50
};
const Spinner = ({
  big = false,
  mTop = '0',
  small = false
}) => {
  const size = big ? SIZES.big : small ? SIZES.small : SIZES.medium;
  const logoSize = Math.round(size * 0.7);
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-loader-wrap",
    style: {
      width: size,
      height: size,
      marginTop: mTop
    }
  }, /*#__PURE__*/React.createElement(Block, {
    margin: "0",
    height: "100%",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("span", {
    className: "gy-heartbeat-ring gy-heartbeat-ring--accent"
  }), /*#__PURE__*/React.createElement("span", {
    className: "gy-heartbeat-ring gy-heartbeat-ring--accentLight"
  }), /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "",
    className: "gy-heartbeat-logo",
    style: {
      width: logoSize,
      height: logoSize
    }
  })));
};
export { Spinner };